export const defaultStructure = {
  type: 'doc',
  attrs: {
    id: null,
    deletable: true,
    appliedThemeId: null,
    pageId: null,
    backgroundColor: 'inherit',
    data: {},
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: '20489355-c46f-4992-a3de-5b799eeb268d',
        lp_name: '',
        deletable: true,
        tokens: {},
        mergeTag: null,
        textAlign: 'center',
        width: '100%',
        stackOnMobile: true,
        borderRadius: '24px 24px 24px 24px',
        appliedThemeId: null,
        position: 'relative',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        positionTopActive: true,
        positionLeftActive: false,
        positionRightActive: true,
        positionBottomActive: false,
        centerHorizontally: false,
        centerVertically: false,
        flexDirection: 'column',
        mobileFlexDirection: 'column',
        backgroundColor: '#FFFFFFFF',
        overflow: 'hidden',
        shadow: 'none',
        blur: '0px',
        backgroundDarken: false,
        horizontalAlign: 'left',
        verticalAlign: 'align_start',
        width_max: '100%',
        mobilePadding: '24px 24px 24px 24px',
        padding: '24px 24px 24px 24px',
        margin: '0px 0px 0px 0px',
        gap: '18px',
        borderWidth: '1px',
        borderColor: '#E5E7EB',
        borderStyle: 'solid',
        flexWrap: 'nowrap',
      },
      content: [
        {
          type: 'container',
          attrs: {
            id: 'd730e290-7287-4320-a417-b25a21449622',
            lp_name: '',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'column',
            backgroundColor: '#ffffff00',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_start',
            width_max: '100%',
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '4px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
          },
          content: [
            {
              type: 'image',
              attrs: {
                id: '7ccf0451-00df-43ea-8114-1028953be0d6',
                lp_name: '',
                tokens: {},
                mergeTag: 'author.image',
                width: 80,
                height: 80,
                aspectRatio: 1,
                boxShadow: 'none',
                appliedThemeId: null,
                url: '',
                open_in_new_tab: false,
                internal_link: false,
                padding: '0px 0px 0px 0px',
                target: null,
                captionUrl: '',
                captionTarget: null,
                src: 'https://beehiiv-images-production.s3.us-east-1.amazonaws.com/dream_builder/Oliver+Buchannon.jpg',
                title: '',
                alt: 'Oliver Buchannon',
                align: 'center',
                captionAlign: 'center',
                borderWidth: '0px',
                objectFit: 'cover',
                borderRadius: '12px 12px 12px 12px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                isFullWidth: false,
              },
            },
          ],
        },
        {
          type: 'container',
          attrs: {
            id: 'd0b50b78-2beb-4dd3-904e-b088c09f2076',
            lp_name: '',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'column',
            backgroundColor: '#ffffff00',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_start',
            width_max: '100%',
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '8px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
          },
          content: [
            {
              type: 'heading',
              attrs: {
                id: 'd91bc002-ace2-49e7-92d1-bad02284f355',
                lp_name: 'Name',
                deletable: true,
                textAlign: 'left',
                tokens: {},
                mergeTag: 'author.name',
                width: '100%',
                maxWidth: '100%',
                appliedThemeId: null,
                level: 5,
                lineClampClass: '',
                backgroundColor: 'transparent',
                borderRadius: '0px',
                borderWidth: '0px',
                borderColor: 'inherit',
                borderStyle: 'none',
                lineHeight: '120%',
                mobileLineHeight: '120%',
                padding: '0px 0px 0px 0px',
                mobilePadding: '0px 0px 0px 0px',
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        mobileFontSize: '20px',
                        fontSize: '20px',
                        fontWeight: '800',
                        fontGradient: null,
                        fontFamily: 'Inter',
                        color: '#030712',
                        tokens: {},
                        appliedThemeId: null,
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Oliver Buchannon',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                id: 'e62059b7-8e08-4209-abc3-0ca34e6391b7',
                lp_name: 'Bio',
                deletable: true,
                textAlign: 'left',
                tokens: {},
                mergeTag: 'author.bio',
                width: '100%',
                maxWidth: '100%',
                appliedThemeId: null,
                backgroundColor: '#ffffff',
                borderRadius: '0px',
                borderWidth: '0px',
                borderColor: 'inherit',
                borderStyle: 'none',
                lineClampClass: '',
                padding: '0px 0px 0px 0px',
                mobilePadding: '0px 0px 0px 0px',
                lineHeight: '120%',
                mobileLineHeight: '120%',
                margin: null,
                postAuthors: [],
                postAuthorsTruncateListEnabled: false,
                postAuthorsByLine: '',
                postTimestampDisplay: 'short_date',
                postReadTimeSuffix: 'min read',
                postTagsTruncateListEnabled: true,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        mobileFontSize: '12px',
                        fontSize: '12px',
                        fontWeight: '400',
                        fontGradient: null,
                        fontFamily: 'Inter',
                        color: '#030712',
                        tokens: {},
                        appliedThemeId: null,
                      },
                    },
                  ],
                  text: 'Oliver Buchannon is a full-stack developer passionate about AI and machine learning. Previously worked at Google and Meta before joining Dream.',
                },
              ],
            },
          ],
        },
        {
          type: 'container',
          attrs: {
            id: 'af46ce23-9310-41f2-9a10-9b85e11a00f0',
            lp_name: '',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'column',
            backgroundColor: '#ffffff00',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_start',
            width_max: '100%',
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '4px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
          },
          content: [
            {
              type: 'socials',
              attrs: {
                id: 'b7942006-0f16-4e2f-836f-831089ff36a5',
                lp_name: '',
                deletable: true,
                tokens: {},
                mergeTag: 'author.socials',
                width: '100%',
                maxWidth: '100%',
                borderRadius: '8px',
                appliedThemeId: null,
                insertedFromSidebar: 'true',
                hasFakeData: 'false',
                isGrouped: 'true',
                iconSize: '14px',
                iconPadding: '4px',
                alignment: 'left',
                padding: '0px',
                gap: '8px',
                shadow: 'none',
                backgroundColor: '#ffffff',
                borderWidth: '1px',
                borderColor: '#ffffff',
                borderStyle: 'none',
                linkedinFill: '#ffffff',
                linkedinBackground: '#030712',
                linkedinBorderWidth: '1px',
                linkedinBorderColor: '#030712',
                linkedinBorderRadius: '8px',
                linkedinBorderStyle: 'none',
                twitterFill: '#ffffff',
                twitterBackground: '#030712',
                twitterBorderWidth: '1px',
                twitterBorderColor: '#030712',
                twitterBorderRadius: '8px',
                twitterBorderStyle: 'none',
                facebookFill: '#ffffff',
                facebookBackground: '#030712',
                facebookBorderWidth: '1px',
                facebookBorderColor: '#030712',
                facebookBorderRadius: '8px',
                facebookBorderStyle: 'none',
                instagramFill: '#ffffff',
                instagramBackground: '#030712',
                instagramBorderWidth: '1px',
                instagramBorderColor: '#030712',
                instagramBorderRadius: '8px',
                instagramBorderStyle: 'none',
                tiktokFill: '#ffffff',
                tiktokBackground: '#030712',
                tiktokBorderWidth: '1px',
                tiktokBorderColor: '#030712',
                tiktokBorderRadius: '8px',
                tiktokBorderStyle: 'none',
                youtubeFill: '#ffffff',
                youtubeBackground: '#030712',
                youtubeBorderWidth: '1px',
                youtubeBorderColor: '#030712',
                youtubeBorderRadius: '8px',
                youtubeBorderStyle: 'none',
                discordFill: '#ffffff',
                discordBackground: '#030712',
                discordBorderWidth: '1px',
                discordBorderColor: '#030712',
                discordBorderRadius: '8px',
                discordBorderStyle: 'none',
                threadsFill: '#ffffff',
                threadsBackground: '#030712',
                threadsBorderWidth: '1px',
                threadsBorderColor: '#030712',
                threadsBorderRadius: '8px',
                threadsBorderStyle: 'none',
                blueskyFill: '#ffffff',
                blueskyBackground: '#030712',
                blueskyBorderWidth: '1px',
                blueskyBorderColor: '#030712',
                blueskyBorderRadius: '8px',
                blueskyBorderStyle: 'none',
                rssFill: '#ffffff',
                rssBackground: '#030712',
                rssBorderWidth: '1px',
                rssBorderColor: '#030712',
                rssBorderRadius: '8px',
                rssBorderStyle: 'none',
                data: {
                  tiktok_url: 'https://tiktok.com/user',
                  discord_url: 'https://discord.com/user',
                  twitter_url: 'https://twitter.com/user',
                  youtube_url: 'https://youtube.com/user',
                  facebook_url: 'https://facebook.com/user',
                  linkedin_url: 'https://linkedin.com/user',
                  instagram_url: 'https://instagram.com/user',
                },
              },
            },
          ],
        },
      ],
    },
  ],
};
